import { useCallback } from 'react';
import { getF1TerminalReceipt } from '@ordr-as/ordr-service-types/epos';
import config from '../config';

const useSoftpayReceipt = () =>
  useCallback(async (paymentReference: string) => {
    const receiptData = await getF1TerminalReceipt(paymentReference);

    const receiptDataJson = encodeURIComponent(receiptData.receipt.join(','));
    const url = `${config.receiptUrl}/${paymentReference}`;

    window.location.href = `intent://favritsoftpay#Intent;scheme=favritsoftpay;package=com.favrit.favritsoftpay;action=android.intent.action.VIEW;S.type="RECEIPT";S.json={"url": "${url}", "data": "${receiptDataJson}"};end`;
  }, []);
export default useSoftpayReceipt;
